import { ErrorText, InputRadio } from '@presentation/components';
import { hasFieldError } from '@presentation/utils';
import { useField } from 'formik';
import { xor } from 'lodash/fp';
import type { PropsWithChildren } from 'react';
// import * as Styled from './components';
import type { InputRadioFieldProps } from './types';

export * from './types';

export const InputRadioField = <TValue,>(
  props: PropsWithChildren<InputRadioFieldProps<TValue>>,
) => {
  const { name, multiple, onSelect, ...rest } = props;
  const [field, meta, helpers] = useField<TValue | TValue[]>(name);

  const value = field.value ?? ((multiple ? [] : undefined) as any);

  return (
    <>
      <InputRadio<TValue>
        {...rest}
        name={name}
        onBlur={field.onBlur}
        value={value}
        multiple={multiple}
        hasError={hasFieldError(meta)}
        onSelect={(selected) => {
          helpers.setTouched(true);
          if (multiple) {            
            helpers.setValue(xor([...(value as TValue[])], [selected.value]));
          } else {
            helpers.setValue(selected.value);
          }
          onSelect?.(selected);
        }}
      />
      {hasFieldError(meta) && <ErrorText>{meta.error}</ErrorText>}
    </>
  );
};
